import { ANALYTICS_ENABLED, type AssessmentAnalyticsEvent } from '../../config/analyticsConfig'

/** Fire optional analytics. Never send PII or raw questionnaire answers. */
export function trackAssessmentEvent(
  event: AssessmentAnalyticsEvent,
  props?: Record<string, string | number | boolean>,
): void {
  if (!ANALYTICS_ENABLED) return
  try {
    const w = window as Window & { gtag?: (...args: unknown[]) => void; dataLayer?: unknown[] }
    if (typeof w.gtag === 'function') {
      w.gtag('event', event, props || {})
      return
    }
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({ event, ...props })
  } catch {
    // Tracking must never break the assessment.
  }
}
